import axios from 'axios';

const instance = axios.create({});

instance.interceptors.request.use(config => {
  const token = localStorage.getItem('hfc_enrollment_token');

  if (token) {
    config.headers.Token = `${token}`;
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default instance;
